module.exports = __webpack_public_path__ + "img/icon-warning.e5274d9b.svg";